/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CloudMessageTargetType {
  None = 'None',
  Android = 'Android',
  IOs = 'iOS'
}
